//const Backofficebff: string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const RetailCommand: any = {
    PostMainRetailDbRemoveById: Backofficebff + '/v1/retaildb/remove-maindb-sale-ids',
    PostTransferRetailDbRemoveById: Backofficebff + '/v1/retaildb/remove-transferdb-sale-ids',
};
